<template>
  <BaseFormField
    :icon="icon"
    :label="label"
    :message="message"
    @icon-click="$emit('icon-click')"
  >
    <input
      :value="value"
      :type="type"
      :disabled="disabled"
      :placeholder="placeholder"
      @blur="$emit('blur')"
      @change="$emit('change')"
      @input="$emit('input', $event.target.value)"
      class="base-input"
    >
  </BaseFormField>
</template>

<script>
import BaseFormField from './BaseFormField.vue';

export default {
    name: 'BaseInput',
    components: { BaseFormField },
    props: {
        value: { type: String, default: undefined },
        icon: { type: String, default: undefined },
        label: { type: String, default: '' },
        type: { type: String, default: 'text' },
        message: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
    },
};
</script>
